<template>
  <section v-if="isLoginFormShow" class="login">
    <!-- 成功消息提示 -->
    <div v-show="successShow" class="block-success">
      <div @click="hide" class="icon-close-grey"></div>
      <img class="icon-success" src="~assets/img/icon-success.png">
      <p class="msg-success">{{ $t(successMsg) }}</p>
      <button @click="backToLogin" class="btn-success">{{ $t('login.know-it') }}</button>
    </div>
    <!-- 登录表单操作 -->
    <div v-show="!successShow" class="form-container">
      <div class="form-header">
        <div @click="hide" class="icon-close"></div>
      </div>
      <div class="form-body">
        <!-- 顶部标签栏 -->
        <ul v-if="display.tabs.main.length" class="tabs">
          <li
            v-for="item in display.tabs.main"
            :key="item.tab"
            @click="updateDisplay(item.tab)"
            :class="[{ active: display.tab === item.tab }, 'tab']"
          >{{ $t(item.text) }}</li>
          <li
            v-if="display.tabs.aside"
            @click="updateDisplay(display.tabs.aside.tab)"
            class="tab-aside"
          >{{ $t(display.tabs.aside.text) }}</li>
        </ul>
        <div class="tab-view-container">
          <!-- 手机输入框 -->
          <div
            v-if="display[inputs.PHONE]"
            :class="['block-phone',  'item', { error: errorMsg[inputs.PHONE] }, { active: focus === inputs.PHONE }]"
          >
            <select v-model="userInput.countryCode" class="input-location">
              <option v-for="(item, idx) in countries" :key="idx" :value="item.code">{{ item.text }}</option>
            </select>
            <input
              @focus="updateFocus(inputs.PHONE)"
              @blur="updateFocus('')"
              v-model="userInput[inputs.PHONE]"
              class="input-phone"
              type="text"
              :placeholder="$t('login.placeholder.phone')"
            >
            <button
              @click="getPhoneCode"
              class="btn-code"
              :disabled="timer[display.tab].cd !== 0"
            >{{ timer[display.tab].cd === 0 ? `${$t('login.get-code')}` : `${$t('login.reget-code')}(${timer[display.tab].cd})` }}</button>
          </div>
          <span
            v-if="display[inputs.PHONE] && errorMsg[inputs.PHONE]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.PHONE]) }}</span>
          <!-- 手机验证码输入框 -->
          <input
            @focus="updateFocus(inputs.PHONE_CODE)"
            @blur="updateFocus('')"
            v-if="display[inputs.PHONE_CODE]"
            v-model="userInput[inputs.PHONE_CODE]"
            type="text"
            :placeholder="$t('login.placeholder.phone-code')"
            :class="['input-normal', 'item', { error: errorMsg[inputs.PHONE_CODE] }, { active: focus === inputs.PHONE_CODE }]"
          >
          <span
            v-if="display[inputs.PHONE_CODE] && errorMsg[inputs.PHONE_CODE]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.PHONE_CODE]) }}</span>
          <!-- 账号输入框 -->
          <input
            @focus="updateFocus(inputs.ACCOUNT)"
            @blur="updateFocus('')"
            v-if="display[inputs.ACCOUNT]"
            v-model="userInput[inputs.ACCOUNT]"
            type="text"
            :class="['input-normal', 'item', { error: errorMsg[inputs.ACCOUNT] }, { active: focus === inputs.ACCOUNT }]"
            :placeholder="$t('login.placeholder.account')"
          >
          <span
            v-if="display[inputs.ACCOUNT] && errorMsg[inputs.ACCOUNT]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.ACCOUNT]) }}</span>
          <!-- 密码输入框 -->
          <div
            v-if="display[inputs.PASSWORD]"
            :class="['block-password', 'item', { error: errorMsg[inputs.PASSWORD] }, { active: focus === inputs.PASSWORD }]"
          >
            <input
              @focus="updateFocus(inputs.PASSWORD)"
              @blur="updateFocus('')"
              v-model="userInput[inputs.PASSWORD]"
              type="password"
              :class="['input-password', { error: errorMsg[inputs.PASSWORD] }]"
              :placeholder="$t('login.placeholder.password')"
            >
            <button
              @click="updateDisplay(tabs.FORGET_PHONE)"
              class="btn-forget"
            >{{ $t('login.forget') }}</button>
          </div>
          <span
            v-if="display[inputs.PASSWORD] && errorMsg[inputs.PASSWORD]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.PASSWORD]) }}</span>
          <!-- 邮箱输入框 -->
          <input
            @focus="updateFocus(inputs.EMAIL)"
            @blur="updateFocus('')"
            v-if="display[inputs.EMAIL]"
            v-model="userInput[inputs.EMAIL]"
            type="text"
            :class="['input-normal', 'item', { error: errorMsg[inputs.EMAIL] }, { active: focus === inputs.EMAIL }]"
            :placeholder="$t('login.placeholder.email')"
          >
          <span
            v-if="display[inputs.EMAIL] && errorMsg[inputs.EMAIL]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.EMAIL]) }}</span>
          <!-- 邮箱验证码输入框 -->
          <div
            v-if="display[inputs.EMAIL_CODE]"
            :class="['block-code-email', 'item', { error: errorMsg[inputs.EMAIL_CODE] }, { active: focus === inputs.EMAIL_CODE }]"
          >
            <input
              @focus="updateFocus(inputs.EMAIL_CODE)"
              @blur="updateFocus('')"
              v-model="userInput[inputs.EMAIL_CODE]"
              type="text"
              class="input-code-email"
              :placeholder="$t('login.placeholder.email-code')"
            >
            <button
              @click="getEmailCode"
              class="btn-code-email"
              :disabled="timer[display.tab].cd !== 0"
            >{{ timer[display.tab].cd === 0 ? `${$t('login.get-code')}` : `${$t('login.reget-code')}(${timer[display.tab].cd})` }}</button>
          </div>
          <span
            v-if="display[inputs.EMAIL_CODE] && errorMsg[inputs.EMAIL_CODE]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.EMAIL_CODE]) }}</span>
          <!-- 注册密码输入框 -->
          <input
            @focus="updateFocus(inputs.PASSWORD_REGIST)"
            @blur="updateFocus('')"
            @keyup="validatePassword"
            v-if="display[inputs.PASSWORD_REGIST]"
            v-model="userInput[inputs.PASSWORD_REGIST]"
            type="password"
            :class="['input-normal', 'item', { error: errorMsg[inputs.PASSWORD_REGIST] }, { active: focus === inputs.PASSWORD_REGIST }]"
            :placeholder="$t('login.placeholder.password')"
          >
          <span
            v-if="display[inputs.PASSWORD_REGIST] && errorMsg[inputs.PASSWORD_REGIST]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.PASSWORD_REGIST]) }}</span>
          <!-- 注册密码确认输入框 -->
          <input
            @focus="updateFocus(inputs.PASSWORD_CONFIRM)"
            @blur="updateFocus('')"
            @keyup="validatePassword"
            v-if="display[inputs.PASSWORD_CONFIRM]"
            v-model="userInput[inputs.PASSWORD_CONFIRM]"
            type="password"
            :class="['input-normal', 'item', { error: errorMsg[inputs.PASSWORD_CONFIRM] }, { active: focus === inputs.PASSWORD_CONFIRM }]"
            :placeholder="$t('login.placeholder.password-confirm')"
          >
          <span
            v-if="display[inputs.PASSWORD_CONFIRM] && errorMsg[inputs.PASSWORD_CONFIRM]"
            class="error-msg"
          >{{ $t(errorMsg[inputs.PASSWORD_CONFIRM]) }}</span>
          <div v-if="display.msg" class="msg">
            <p :key="text" v-for="text in msg">{{text}}</p>
          </div>
          <!-- 提交按钮 -->
          <button @click="submit" class="btn-submit item">{{ $t(display.submitText) }}</button>
        </div>
        <p class="service-agreement">
          {{$t('login.agreement.agree')}}
          <a
            href="/agreement"
            target="_blank"
          >{{$t('login.agreement.service-agreement')}}</a>
        </p>
        <!-- <div class="login-other-way">
          <div class="divider">
            <span class="title">第三方登录</span>
          </div>
          <ul class="btn-icon-group">
            <li class="btn-icon btn-weibo"></li>
            <li class="btn-icon btn-qq"></li>
            <li class="btn-icon btn-wechat"></li>
          </ul>
        </div>-->
      </div>
    </div>
  </section>
</template>
<script>
import * as userApi from "~/api/user";
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import * as types from "~/types";

const tabs = {
  LOGIN_PHONE: "LOGIN_PHONE",
  LOGIN_ACCOUNT: "LOGIN_ACCOUNT",
  FORGET_PHONE: "FORGET_PHONE",
  FORGET_EMAIL: "FORGET_EMAIL",
  REGIST_PHONE: "REGIST_PHONE",
  MESSAGE: "MESSAGE"
};

// 显示在左侧的tab的集合
const tabMainItem = {
  [tabs.LOGIN_PHONE]: {
    text: "login.tabs.main.phone-login",
    tab: tabs.LOGIN_PHONE
  },
  [tabs.LOGIN_ACCOUNT]: {
    text: "login.tabs.main.account-login",
    tab: tabs.LOGIN_ACCOUNT
  },
  [tabs.REGIST_PHONE]: {
    text: "login.tabs.main.phone-regist",
    tab: tabs.REGIST_PHONE
  },
  [tabs.FORGET_PHONE]: {
    text: "login.tabs.main.phone-forget",
    tab: tabs.FORGET_PHONE
  },
  [tabs.FORGET_EMAIL]: {
    text: "login.tabs.main.email-forget",
    tab: tabs.FORGET_EMAIL
  }
};

// 显示在右侧的tab的集合
const tabAsideItem = {
  [tabs.REGIST_PHONE]: {
    text: "login.tabs.aside.phone-regist",
    tab: tabs.REGIST_PHONE
  },
  [tabs.FORGET_EMAIL]: {
    text: "login.tabs.aside.email-forget",
    tab: tabs.FORGET_EMAIL
  },
  [tabs.FORGET_PHONE]: {
    text: "login.tabs.aside.phone-forget",
    tab: tabs.FORGET_PHONE
  },
  [tabs.LOGIN_PHONE]: {
    text: "login.tabs.aside.phone-login",
    tab: tabs.LOGIN_PHONE
  }
};

// 需要进行校验的用户输入
const inputs = {
  PHONE: "PHONE",
  PHONE_CODE: "PHONE_CODE",
  ACCOUNT: "ACCOUNT",
  PASSWORD: "PASSWORD",
  EMAIL: "EMAIL",
  EMAIL_CODE: "EMAIL_CODE",
  PASSWORD_REGIST: "PASSWORD_REGIST",
  PASSWORD_CONFIRM: "PASSWORD_CONFIRM"
};

// 各个标签显示内容的配置
const tabDisplayConfig = {
  // 手机快捷登录
  [tabs.LOGIN_PHONE]: {
    tabs: {
      main: [tabMainItem[tabs.LOGIN_PHONE], tabMainItem[tabs.LOGIN_ACCOUNT]],
      aside: tabAsideItem[tabs.REGIST_PHONE]
    },
    submitText: "login.submit.login",
    [inputs.PHONE]: true,
    [inputs.PHONE_CODE]: true
  },
  // 账号登录
  [tabs.LOGIN_ACCOUNT]: {
    tabs: {
      main: [tabMainItem[tabs.LOGIN_PHONE], tabMainItem[tabs.LOGIN_ACCOUNT]],
      aside: tabAsideItem[tabs.REGIST_PHONE]
    },
    submitText: "login.submit.login",
    [inputs.ACCOUNT]: true,
    [inputs.PASSWORD]: true
  },
  // 忘记密码 - 手机找回
  [tabs.FORGET_PHONE]: {
    tabs: {
      main: [tabMainItem[tabs.FORGET_PHONE]],
      aside: tabAsideItem[tabs.FORGET_EMAIL]
    },
    submitText: "login.submit.commit",
    [inputs.PHONE]: true,
    [inputs.PHONE_CODE]: true,
    [inputs.PASSWORD_REGIST]: true,
    [inputs.PASSWORD_CONFIRM]: true
  },
  // 忘记密码 - 邮箱找回
  [tabs.FORGET_EMAIL]: {
    tabs: {
      main: [tabMainItem[tabs.FORGET_EMAIL]],
      aside: tabAsideItem[tabs.FORGET_PHONE]
    },
    submitText: "login.submit.commit",
    [inputs.EMAIL]: true,
    [inputs.EMAIL_CODE]: true,
    [inputs.PASSWORD_REGIST]: true,
    [inputs.PASSWORD_CONFIRM]: true
  },
  // 注册
  [tabs.REGIST_PHONE]: {
    tabs: {
      main: [tabMainItem[tabs.REGIST_PHONE]],
      aside: tabAsideItem[tabs.LOGIN_PHONE]
    },
    submitText: "login.submit.regist",
    [inputs.PHONE]: true,
    [inputs.PHONE_CODE]: true,
    [inputs.PASSWORD_REGIST]: true,
    [inputs.PASSWORD_CONFIRM]: true
  },
  [tabs.MESSAGE]: {
    tabs: {
      main: [],
      aside: null
    },
    submitText: "login.submit.login-immediately",
    msg: true
  }
};

// 校验规则
const validateRules = {
  PHONE_EMPTY: {
    check: src => src !== "",
    msg: "login.error.phone-empty",
    inputType: inputs.PHONE
  },
  PHONE_CODE_EMPTY: {
    check: src => src !== "",
    msg: "login.error.phone-code-empty",
    inputType: inputs.PHONE_CODE
  },
  ACCOUNT_EMPTY: {
    check: src => src !== "",
    msg: "login.error.account-empty",
    inputType: inputs.ACCOUNT
  },
  PASSWORD_EMPTY: {
    check: src => src !== "",
    msg: "login.error.password-empty",
    inputType: inputs.PASSWORD
  },
  PASSWORD_REGIST_EMPTY: {
    check: src => src !== "",
    msg: "login.error.password-empty",
    inputType: inputs.PASSWORD_REGIST
  },
  EMAIL_EMPTY: {
    check: src => src !== "",
    msg: "login.error.email-empty",
    inputType: inputs.EMAIL
  },
  EMAIL_CODE_EMPTY: {
    check: src => src !== "",
    msg: "login.error.email-code-empty",
    inputType: inputs.EMAIL_CODE
  }
};

export default {
  data: () => ({
    userInput: {
      [inputs.PHONE]: "",
      [inputs.PHONE_CODE]: "",
      [inputs.ACCOUNT]: "",
      [inputs.PASSWORD]: "",
      [inputs.EMAIL]: "",
      [inputs.EMAIL_CODE]: "",
      [inputs.PASSWORD_REGIST]: "",
      [inputs.PASSWORD_CONFIRM]: "",

      countryCode: "86"
    },
    // 错误信息的显示
    errorMsg: {
      [inputs.PHONE]: "",
      [inputs.PHONE_CODE]: "",
      [inputs.ACCOUNT]: "",
      [inputs.PASSWORD]: "",
      [inputs.EMAIL]: "",
      [inputs.EMAIL_CODE]: "",
      [inputs.PASSWORD_REGIST]: "",
      [inputs.PASSWORD_CONFIRM]: ""
    },
    // 挂载上供模板使用
    tabs,
    inputs,
    tabDisplayConfig,
    // 显示相关配置
    display: {
      [inputs.PHONE]: false,
      [inputs.PHONE_CODE]: false,
      [inputs.ACCOUNT]: false,
      [inputs.PASSWORD]: false,
      [inputs.EMAIL]: false,
      [inputs.EMAIL_CODE]: false,
      [inputs.PASSWORD_REGIST]: false,
      [inputs.PASSWORD_CONFIRM]: false,
      msg: false,

      tabs: {
        main: [],
        aside: null
      },
      tab: "",
      submitText: ""
    },
    // 用于验证码冷却时间的计时器
    timer: {
      [tabs.LOGIN_PHONE]: {
        createdAt: 0,
        id: null,
        cd: 0
      },
      [tabs.FORGET_PHONE]: {
        createdAt: 0,
        id: null,
        cd: 0
      },
      [tabs.REGIST_PHONE]: {
        createdAt: 0,
        id: null,
        cd: 0
      },
      [tabs.FORGET_EMAIL]: {
        createdAt: 0,
        id: null,
        cd: 0
      }
    },
    msg: [],
    successMsg: "",
    successShow: false,
    focus: "",
    countries: [
      { text: "中国", code: "86" },
      { text: "中国澳门", code: "853" },
      { text: "中国台湾", code: "886" },
      { text: "中国香港", code: "852" },
      { text: "阿尔巴尼亚", code: "355" },
      { text: "阿尔及利亚", code: "213" },
      { text: "阿富汗", code: "93" },
      { text: "阿根廷", code: "54" },
      { text: "爱尔兰", code: "353" },
      { text: "埃及", code: "20" },
      { text: "埃塞俄比亚", code: "251" },
      { text: "爱沙尼亚", code: "372" },
      { text: "阿拉伯联合酋长国", code: "971" },
      { text: "阿鲁巴", code: "297" },
      { text: "阿曼", code: "968" },
      { text: "安道尔", code: "376" },
      { text: "安哥拉", code: "244" },
      { text: "安圭拉", code: "1264" },
      { text: "安提瓜和巴布达", code: "1268" },
      { text: "澳大利亚", code: "61" },
      { text: "奥地利", code: "43" },
      { text: "阿塞拜疆", code: "994" },
      { text: "巴巴多斯", code: "1246" },
      { text: "巴布亚新几内亚", code: "675" },
      { text: "巴哈马", code: "1242" },
      { text: "白俄罗斯", code: "375" },
      { text: "百慕大慕大群岛", code: "1441" },
      { text: "巴基斯坦", code: "92" },
      { text: "巴拉圭", code: "595" },
      { text: "巴勒斯坦", code: "970" },
      { text: "巴林", code: "973" },
      { text: "巴拿马", code: "507" },
      { text: "保加利亚", code: "359" },
      { text: "巴西", code: "55" },
      { text: "贝宁", code: "229" },
      { text: "比利时", code: "32" },
      { text: "冰岛", code: "354" },
      { text: "博茨瓦纳", code: "267" },
      { text: "波多黎各", code: "1787" },
      { text: "波兰", code: "48" },
      { text: "玻利维亚", code: "591" },
      { text: "伯利兹", code: "501" },
      { text: "波斯尼亚和黑塞哥维那", code: "387" },
      { text: "不丹", code: "975" },
      { text: "布基纳法索", code: "226" },
      { text: "布隆迪", code: "257" },
      { text: "赤道几内亚", code: "240" },
      { text: "丹麦", code: "45" },
      { text: "德国", code: "49" },
      { text: "东帝汶", code: "670" },
      { text: "多哥", code: "228" },
      { text: "多米尼加", code: "1767" },
      { text: "厄瓜多尔", code: "593" },
      { text: "俄罗斯", code: "7" },
      { text: "法国", code: "33" },
      { text: "法罗群岛", code: "298" },
      { text: "法属波利尼西亚", code: "689" },
      { text: "法属圭亚那", code: "594" },
      { text: "斐济", code: "679" },
      { text: "菲律宾", code: "63" },
      { text: "芬兰", code: "358" },
      { text: "冈比亚", code: "220" },
      { text: "刚果共和国", code: "242" },
      { text: "刚果民主共和国", code: "243" },
      { text: "格陵兰岛", code: "299" },
      { text: "格林纳达", code: "1473" },
      { text: "格鲁吉亚", code: "995" },
      { text: "哥伦比亚", code: "57" },
      { text: "哥斯达黎加", code: "506" },
      { text: "瓜德罗普岛", code: "590" },
      { text: "瓜地马拉", code: "502" },
      { text: "关岛", code: "1671" },
      { text: "古巴", code: "53" },
      { text: "圭亚那", code: "592" },
      { text: "海地", code: "509" },
      { text: "韩国", code: "82" },
      { text: "哈萨克斯坦", code: "7" },
      { text: "黑山", code: "382" },
      { text: "荷兰", code: "31" },
      { text: "洪都拉斯", code: "504" },
      { text: "加纳", code: "233" },
      { text: "加拿大", code: "1" },
      { text: "柬埔寨", code: "855" },
      { text: "加蓬", code: "241" },
      { text: "吉布提", code: "253" },
      { text: "捷克", code: "420" },
      { text: "吉尔吉斯斯坦", code: "996" },
      { text: "基里巴斯", code: "686" },
      { text: "津巴布韦", code: "263" },
      { text: "几内亚", code: "224" },
      { text: "几内亚比绍共和国", code: "245" },
      { text: "开曼群岛", code: "1345" },
      { text: "开普", code: "238" },
      { text: "喀麦隆", code: "237" },
      { text: "卡塔尔", code: "974" },
      { text: "克罗地亚", code: "385" },
      { text: "科摩罗", code: "269" },
      { text: "肯尼亚", code: "254" },
      { text: "科威特", code: "965" },
      { text: "库克群岛", code: "682" },
      { text: "库拉索", code: "599" },
      { text: "莱索托", code: "266" },
      { text: "老挝", code: "856" },
      { text: "拉脱维亚", code: "371" },
      { text: "黎巴嫩", code: "961" },
      { text: "利比里亚", code: "231" },
      { text: "利比亚", code: "218" },
      { text: "列支敦士登", code: "423" },
      { text: "立陶宛", code: "370" },
      { text: "留尼汪", code: "262" },
      { text: "罗马尼亚", code: "40" },
      { text: "卢森堡", code: "352" },
      { text: "卢旺达", code: "250" },
      { text: "马达加斯加", code: "261" },
      { text: "马尔代夫", code: "960" },
      { text: "马耳他", code: "356" },
      { text: "马来西亚", code: "60" },
      { text: "马拉维", code: "265" },
      { text: "马里", code: "223" },
      { text: "毛里求斯", code: "230" },
      { text: "毛里塔尼亚", code: "222" },
      { text: "马其顿", code: "389" },
      { text: "马提尼克", code: "596" },
      { text: "马约特", code: "269" },
      { text: "美国", code: "1" },
      { text: "美属萨摩亚", code: "1684" },
      { text: "美属维尔京群岛", code: "1284" },
      { text: "蒙古", code: "976" },
      { text: "孟加拉国", code: "880" },
      { text: "蒙特塞拉特岛", code: "1664" },
      { text: "缅甸", code: "95" },
      { text: "秘鲁", code: "51" },
      { text: "摩尔多瓦", code: "373" },
      { text: "摩洛哥", code: "212" },
      { text: "摩纳哥", code: "377" },
      { text: "莫桑比克", code: "258" },
      { text: "墨西哥", code: "52" },
      { text: "纳米比亚", code: "264" },
      { text: "南非", code: "27" },
      { text: "尼加拉瓜", code: "505" },
      { text: "尼泊尔", code: "977" },
      { text: "尼日尔", code: "227" },
      { text: "尼日利亚", code: "234" },
      { text: "挪威", code: "47" },
      { text: "帕劳", code: "680" },
      { text: "葡萄牙", code: "351" },
      { text: "日本", code: "81" },
      { text: "瑞典", code: "46" },
      { text: "瑞士", code: "41" },
      { text: "萨尔瓦多", code: "503" },
      { text: "塞尔维亚", code: "381" },
      { text: "塞拉利昂", code: "232" },
      { text: "塞内加尔", code: "221" },
      { text: "塞浦路斯", code: "357" },
      { text: "塞舌尔", code: "248" },
      { text: "萨摩亚", code: "685" },
      { text: "沙特阿拉伯", code: "966" },
      { text: "圣彼埃尔和密克隆岛", code: "508" },
      { text: "圣多美和普林西比", code: "239" },
      { text: "圣基茨和尼维斯", code: "1869" },
      { text: "圣露西亚", code: "1758" },
      { text: "圣马丁岛（荷兰部分）", code: "1721" },
      { text: "圣马力诺", code: "378" },
      { text: "圣文森特和格林纳丁斯", code: "1784" },
      { text: "斯里兰卡", code: "94" },
      { text: "斯洛伐克", code: "421" },
      { text: "斯洛文尼亚", code: "386" },
      { text: "斯威士兰", code: "268" },
      { text: "苏丹", code: "249" },
      { text: "苏里南", code: "597" },
      { text: "所罗门群岛", code: "677" },
      { text: "索马里", code: "252" },
      { text: "泰国", code: "66" },
      { text: "塔吉克斯坦", code: "992" },
      { text: "汤加", code: "676" },
      { text: "坦桑尼亚", code: "255" },
      { text: "特克斯和凯科斯群岛", code: "1649" },
      { text: "特立尼达和多巴哥", code: "1868" },
      { text: "土耳其", code: "90" },
      { text: "土库曼斯坦", code: "993" },
      { text: "突尼斯", code: "216" },
      { text: "瓦努阿图", code: "678" },
      { text: "委内瑞拉", code: "58" },
      { text: "文莱", code: "673" },
      { text: "乌干达", code: "256" },
      { text: "乌克兰", code: "380" },
      { text: "乌拉圭", code: "598" },
      { text: "乌兹别克斯坦", code: "998" },
      { text: "象牙海岸", code: "225" },
      { text: "西班牙", code: "34" },
      { text: "希腊", code: "30" },
      { text: "新加坡", code: "65" },
      { text: "新喀里多尼亚", code: "687" },
      { text: "新西兰", code: "64" },
      { text: "匈牙利", code: "36" },
      { text: "叙利亚", code: "963" },
      { text: "牙买加", code: "1876" },
      { text: "亚美尼亚", code: "374" },
      { text: "也门", code: "967" },
      { text: "意大利", code: "39" },
      { text: "伊拉克", code: "964" },
      { text: "伊朗", code: "98" },
      { text: "印度", code: "91" },
      { text: "印度尼西亚", code: "62" },
      { text: "英国", code: "44" },
      { text: "英属处女群岛", code: "1340" },
      { text: "以色列", code: "972" },
      { text: "约旦", code: "962" },
      { text: "越南", code: "84" },
      { text: "赞比亚", code: "260" },
      { text: "乍得", code: "235" },
      { text: "直布罗陀", code: "350" },
      { text: "智利", code: "56" },
      { text: "中非共和国", code: "236" }
    ]
  }),
  computed: {
    isSamePassword() {
      const {
        [inputs.PASSWORD_REGIST]: password,
        [inputs.PASSWORD_CONFIRM]: passwordConfirm
      } = this.userInput;
      return password === passwordConfirm;
    },
    ...mapState("user", ["isLoginFormShow", "isRegistFirst"])
  },
  methods: {
    // 第一次登录的用户需要调用一次同意用户合同操作
    async agreeAgreement() {
      try {
        let res = await this.$axios(userApi.agreeAgreement());
      } catch (e) {}
    },
    updateDisplay(tab) {
      this.clearErrorMsg();
      const { display } = this;
      display.tab = tab;
      const config = this.tabDisplayConfig[tab];

      display.tabs.main = config.tabs.main || [];
      display.tabs.aside = config.tabs.aside || null;
      display.submitText = config.submitText || "login.submit.commit";

      this.clearInput();

      display[inputs.PHONE] = config[inputs.PHONE] || false;
      display[inputs.PHONE_CODE] = config[inputs.PHONE] || false;
      display[inputs.ACCOUNT] = config[inputs.ACCOUNT] || false;
      display[inputs.PASSWORD] = config[inputs.PASSWORD] || false;
      display[inputs.EMAIL] = config[inputs.EMAIL] || false;
      display[inputs.EMAIL_CODE] = config[inputs.EMAIL_CODE] || false;
      display[inputs.PASSWORD_REGIST] = config[inputs.PASSWORD_REGIST] || false;
      display[inputs.PASSWORD_CONFIRM] =
        config[inputs.PASSWORD_CONFIRM] || false;
      display.msg = config.msg || false;
    },
    // 验证码冷却计时器的入口
    startTick(type) {
      this.timer[type].id = setInterval(() => {
        this.timerTick(type);
      }, 1000);
      this.timer[type].createdAt = Date.now();
    },
    // 验证码冷却计时器的step函数
    timerTick(type) {
      const val = Math.floor((Date.now() - this.timer[type].createdAt) / 1000);
      this.timer[type].cd = Math.max(60 - val, 0);
      if (this.timer[type].cd === 0) {
        clearInterval(this.timer[type].id);
        this.timer[type].createdAt = 0;
      }
    },
    // 校验规则并输出对应的错误信息
    validate(...rules) {
      let isSuccess = true;
      const { userInput, errorMsg } = this;
      rules.forEach(rule => {
        const { check, msg, inputType } = rule;
        if (!check(userInput[inputType])) {
          errorMsg[inputType] = msg;
          isSuccess = false;
        }
      });
      return isSuccess;
    },
    validatePassword() {
      const {
        [inputs.PASSWORD_REGIST]: password,
        [inputs.PASSWORD_CONFIRM]: passwordConfirm
      } = this.userInput;
      if (password !== passwordConfirm && passwordConfirm !== "") {
        this.errorMsg[inputs.PASSWORD_CONFIRM] = "login.error.password-confirm";
      } else {
        this.errorMsg[inputs.PASSWORD_CONFIRM] = "";
      }
    },
    getPhoneCode() {
      this.clearErrorMsg();
      if (!this.validate(validateRules.PHONE_EMPTY)) {
        return;
      }
      const { [inputs.PHONE]: phone, countryCode } = this.userInput;
      let pros = null;
      const { tab } = this.display;
      switch (tab) {
        case tabs.LOGIN_PHONE:
          pros = this.$axios(
            userApi.getFastLoginPhoneCode({ phone, countryCode })
          );
          break;
        case tabs.FORGET_PHONE:
          pros = this.$axios(
            userApi.getForgotPhoneCode({ phone, countryCode })
          );
          break;
        case tabs.REGIST_PHONE:
          pros = this.$axios(
            userApi.getRegistPhoneCode({ phone, countryCode })
          );
          break;
        default:
          break;
      }
      if (pros === null) {
        return;
      }
      pros
        .then(res => {
          if (res.statusCode === 200) {
            this.startTick(tab);
          } else if (
            res.statusCode === 406 &&
            (res.message === "验证码发送失败，手机号已被注册" ||
              res.message === "驗證碼發送失敗，手機號已被註冊")
          ) {
            // 获取注册验证码时可获得手机号是否被注册的反馈
            // 根据 statusCode 与 message 进行强匹配 避免与其他接口的逻辑冲突
            this.msg = [phone, this.$t("login.msg.phone-exits")];
            this.updateDisplay(tabs.MESSAGE);
          } else {
            this.errorMsg[inputs.PHONE] = res.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmailCode() {
      this.clearErrorMsg();
      if (!this.validate(validateRules.EMAIL_EMPTY)) {
        return;
      }
      const { [inputs.EMAIL]: email } = this.userInput;
      this.$axios(
        userApi.getForgotEmailCode({ user: { email: email }, picCode: "" })
      )
        .then(res => {
          console.log(res);
          if (res.statusCode === 200) {
            this.startTick(this.display.tab);
          } else if (
            res.statusCode === 406 &&
            (res.message === "操作过于频繁，一分钟内只能发送一条验证码" ||
              res.message === "操作過於頻繁，一分鐘內只能發送一條驗證碼")
          ) {
            this.errorMsg[inputs.EMAIL_CODE] = res.message;
          } else {
            this.errorMsg[inputs.EMAIL] = res.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loginPhone() {
      if (
        !this.validate(
          validateRules.PHONE_EMPTY,
          validateRules.PHONE_CODE_EMPTY
        )
      ) {
        return;
      }
      const {
        [inputs.PHONE]: phone,
        [inputs.PHONE_CODE]: phoneCode,
        countryCode
      } = this.userInput;
      this.$axios(
        userApi.getFastLogin({
          phone,
          phoneCode,
          countryCode
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this.signIn(res.result);
            this.getFollows();
            this.getStockFollows();
            this.hide();
            if (!res.result.agreeUserAgreement) {
              // TODO: 调用同意合同接口
              this.agreeAgreement();
            }
          } else {
            this.errorMsg[inputs.PHONE_CODE] = res.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loginAccount() {
      if (
        !this.validate(
          validateRules.ACCOUNT_EMPTY,
          validateRules.PASSWORD_EMPTY
        )
      ) {
        return;
      }
      const {
        [inputs.ACCOUNT]: account,
        [inputs.PASSWORD]: password
      } = this.userInput;
      this.$axios(
        userApi.loginAccount({
          account,
          password
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this.signIn(res.result);
            this.getFollows();
            this.getStockFollows();
            this.hide();
            if (!res.result.agreeUserAgreement) {
              // TODO: 调用同意合同接口
              this.agreeAgreement();
            }
          } else {
            this.errorMsg[inputs.ACCOUNT] = res.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    registPhone() {
      const {
        PHONE_EMPTY,
        PHONE_CODE_EMPTY,
        PASSWORD_REGIST_EMPTY
      } = validateRules;
      if (
        !this.validate(PHONE_EMPTY, PHONE_CODE_EMPTY, PASSWORD_REGIST_EMPTY) ||
        !this.isSamePassword
      ) {
        return;
      }
      const {
        [inputs.PHONE]: phone,
        [inputs.PHONE_CODE]: phoneCode,
        [inputs.PASSWORD_REGIST]: password,
        [inputs.PASSWORD_CONFIRM]: passwordConfirm,
        countryCode
      } = this.userInput;
      this.$axios(
        userApi.registPhone({
          phone,
          phoneCode,
          password,
          passwordConfirm,
          countryCode
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this.successMsg = "login.msg.regist-success";
            this.successShow = true;
          } else {
            this.errorMsg[inputs.PASSWORD_REGIST] = res.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    forgotPhone() {
      const {
        PHONE_EMPTY,
        PHONE_CODE_EMPTY,
        PASSWORD_REGIST_EMPTY
      } = validateRules;
      if (
        !this.validate(PHONE_EMPTY, PHONE_CODE_EMPTY, PASSWORD_REGIST_EMPTY) ||
        !this.isSamePassword
      ) {
        return;
      }
      const {
        [inputs.PHONE]: phone,
        [inputs.PHONE_CODE]: phoneCode,
        [inputs.PASSWORD_REGIST]: password,
        [inputs.PASSWORD_CONFIRM]: passwordConfirm,
        countryCode
      } = this.userInput;
      this.$axios(
        userApi.resetPasswordPhone({
          phone,
          phoneCode,
          password,
          passwordConfirm,
          countryCode
        })
      )
        .then(res => {
          if (res.statusCode === 200) {
            this.successMsg = "login.msg.reset-success";
            this.successShow = true;
          } else {
            this.errorMsg[inputs.PHONE_CODE] = res.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    forgotEmail() {
      const {
        EMAIL_EMPTY,
        EMAIL_CODE_EMPTY,
        PASSWORD_REGIST_EMPTY
      } = validateRules;
      if (
        !this.validate(EMAIL_EMPTY, EMAIL_CODE_EMPTY, PASSWORD_REGIST_EMPTY) ||
        !this.isSamePassword
      ) {
        return;
      }
      const {
        [inputs.EMAIL]: email,
        [inputs.EMAIL_CODE]: emailCode,
        [inputs.PASSWORD_REGIST]: password,
        [inputs.PASSWORD_CONFIRM]: passwordConfirm
      } = this.userInput;
      this.$axios(userApi.resetPasswordEmail({ emailCode, email, password }))
        .then(res => {
          if (res.statusCode === 200) {
            this.successMsg = "login.msg.reset-success";
            this.successShow = true;
          } else {
            this.errorMsg[inputs.EMAIL] = res.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submit() {
      const { tab } = this.display;
      this.clearErrorMsg();
      switch (tab) {
        case tabs.LOGIN_PHONE:
          this.loginPhone();
          break;
        case tabs.LOGIN_ACCOUNT:
          this.loginAccount();
          break;
        case tabs.REGIST_PHONE:
          this.registPhone();
          break;
        case tabs.FORGET_PHONE:
          this.forgotPhone();
          break;
        case tabs.FORGET_EMAIL:
          this.forgotEmail();
          break;
        case tabs.MESSAGE:
          this.updateDisplay(tabs.LOGIN_PHONE);
          break;
        default:
          break;
      }
    },
    backToLogin() {
      this.successShow = false;
      this.updateDisplay(tabs.LOGIN_PHONE);
    },
    clearErrorMsg() {
      for (let name in this.errorMsg) {
        this.errorMsg[name] = "";
      }
    },
    clearTimer() {
      for (let name in this.timer) {
        const timer = this.timer[name];
        clearInterval(timer.id);
        timer.createdAt = 0;
        timer.cd = 0;
      }
    },
    clearInput() {
      const { userInput } = this;
      userInput[inputs.PHONE] = "";
      userInput[inputs.PHONE_CODE] = "";
      userInput[inputs.ACCOUNT] = "";
      userInput[inputs.PASSWORD] = "";
      userInput[inputs.EMAIL] = "";
      userInput[inputs.EMAIL_CODE] = "";
      userInput[inputs.PASSWORD_REGIST] = "";
      userInput[inputs.PASSWORD_CONFIRM] = "";
    },
    updateFocus(inputType) {
      this.focus = inputType;
    },
    ...mapMutations("user", {
      signIn: types.USER_SIGNIN,
      hide: types.HIDE_LOGIN_FORM
    }),
    ...mapActions("user", {
      loginLocal: types.LOGIN_LOCAL,
      getFollows: types.GET_FOLLOWS,
      getStockFollows: types.GET_STOCK_FOCUS
    })
  },
  mounted() {
    this.loginLocal();
  },
  created() {
    this.updateDisplay(tabs.LOGIN_PHONE);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  watch: {
    isLoginFormShow(isShow) {
      if (!isShow) {
        return;
      }
      this.clearErrorMsg();
      this.clearTimer();
      if (this.isRegistFirst) {
        this.updateDisplay(tabs.REGIST_PHONE);
      } else {
        this.updateDisplay(tabs.LOGIN_PHONE);
      }
    }
  }
};
</script>
<style lang="less" scoped>
@bg-input: #f3f5f9;
@bg-input-active: #fff;
@outline-active: #3278d2;

.login {
  position: fixed;
  bottom: 0;
  z-index: 1000;

  width: 100vw !important;
  height: 100%;

  background: rgba(0, 0, 0, 0.55);
}

.block-success {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  height: 330px;
  width: 320px;
  margin: auto;

  background: #fff;
  border-radius: 4px;
}

.icon-success {
  position: absolute;
  left: 0;
  right: 0;
  top: 52px;

  margin: auto;
}

.msg-success {
  position: absolute;
  top: 202px;
  left: 0;
  right: 0;

  text-align: center;
}

.btn-success {
  position: absolute;
  top: 250px;
  left: 0;
  right: 0;

  width: 258px;
  height: 40px;
  margin: auto;

  font-size: 16px;

  color: #fff;
  background: #f93;
  cursor: pointer;
}

.icon-close,
.icon-close-grey {
  position: absolute;
  right: 20px;
  top: 20px;

  width: 14px;
  height: 14px;

  background: center/contain url("~assets/img/icon-close.png");
  cursor: pointer;
}

.icon-close-grey {
  background: center/contain url("~assets/img/icon-close-grey.png");
}

.form-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;

  width: 450px;
  margin: auto;

  transform: translateY(-50%);

  > .form-header {
    height: 120px;

    background: url("~assets/img/banner.png");
  }

  > .form-body {
    padding: 40px;

    background: #fff;
  }
}

.tabs {
  position: relative;

  margin-bottom: 36px;
  border-bottom: 1px solid #f3f3f3;

  font-size: 0;

  > .tab {
    display: inline-block;

    padding: 6px 0;

    font-size: 16px;

    cursor: pointer;

    &:hover {
      color: #3278d2;
    }

    &.active {
      border-bottom: 3px solid #3278d2;

      color: #000;
    }
  }

  .tab + .tab {
    margin-left: 12px;
  }

  > .tab-aside {
    position: absolute;
    bottom: 12px;
    right: 4px;

    font-size: 14px;

    color: #999;
    cursor: pointer;
  }
}

.item ~ .item {
  margin-top: 24px;
}

.item.error {
  outline: 1px solid #f00;
}

// 手机输入框
.block-phone {
  display: flex;

  padding: 0 6px 0 12px;
  height: 50px;
  font-size: 0;

  background: @bg-input;
  border-radius: 2px;

  > .input-location {
    border: none;
    width: 60px;
    background: url("https://cdn.gelonghui.com/static/web/arrow.png") right
      center no-repeat;
    background-size: 14px;
    font-size: 14px;
    // background: @bg-input;
  }

  > .input-phone {
    width: 180px;
    border: none;

    font-size: 16px;
    text-indent: 5px;
    background: @bg-input;
    outline: none;
  }

  &.active {
    background: @bg-input-active;
    outline: 1px solid @outline-active;

    > .input-location {
      background-color: @bg-input-active;
    }

    > .input-phone {
      background: @bg-input-active;
      box-shadow: 0 0 0 1000px @bg-input-active inset !important;
    }

    > .btn-code {
      background: @bg-input-active;
    }
  }
}

.error-msg {
  position: absolute;

  margin-top: 2px;

  font-size: 12px;

  color: #f00;
}

.btn-code,
.btn-code-email,
.btn-forget {
  padding-left: 12px;
  border-left: 1px solid #ccc;
  font-size: 14px;
  color: #666;
  background: @bg-input;
  cursor: pointer;
  height: 25px;
  margin: auto;
}

.btn-forget {
  padding-left: 24px;
}

.input-normal {
  display: block;
  box-sizing: border-box;

  width: 100%;
  padding: 0 21px;
  height: 50px;
  border: none;

  font-size: 16px;

  background: @bg-input;
  outline: none;

  &.active {
    background: @bg-input-active;
    outline: 1px solid @outline-active;
    box-shadow: 0 0 0 1000px @bg-input-active inset !important;
  }
}

.btn-submit {
  display: block;

  width: 100%;
  padding: 17px 0;
  margin-top: 34px;

  background: #3278d2;
  color: #fff;
  cursor: pointer;
}

.block-password,
.block-code-email {
  display: flex;
  padding: 0 21px;
  height: 50px;
  font-size: 0;

  background: @bg-input;

  .input-password,
  .input-code-email {
    width: 200px;
    border: none;

    font-size: 16px;

    background: @bg-input;
    outline: none;
  }

  &.active {
    background: @bg-input-active;
    outline: 1px solid @outline-active;

    & > .btn-forget,
    & > .btn-code-email {
      background: @bg-input-active;
    }

    & > .input-password,
    & > .input-code-email {
      background: @bg-input-active;
      box-shadow: 0 0 0 1000px @bg-input-active inset !important;
    }
  }
}

.msg {
  text-align: center;

  & > p {
    margin-top: 12px;
  }
}

.divider {
  display: table;
  position: relative;

  width: 100%;
  margin: 30px 0;

  text-align: center;
  font-size: 14px;

  color: #999;

  &::before,
  &::after {
    content: " ";

    display: table-cell;
    position: relative;
    top: 50%;

    width: 138px;

    border-top: 1px solid #e8e8e8;

    transform: translateY(50%);
  }
}

.btn-icon-group {
  font-size: 0;
  text-align: center;

  > .btn-icon {
    display: inline-block;

    width: 50px;
    height: 50px;

    border-radius: 50%;
    cursor: pointer;

    & + .btn-icon {
      margin-left: 55px;
    }
  }

  .btn-weibo {
    background: no-repeat center url("~assets/img/icon_weibo.png");
  }
  .btn-qq {
    background: no-repeat center url("~assets/img/icon_qq.png");
  }
  .btn-wechat {
    background: no-repeat center url("~assets/img/icon_wechat.png");
  }
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  box-shadow: 0 0 0 1000px @bg-input inset;
}
input[type="text"]:focus,
input[type="password"]:focus,
textarea:focus {
  box-shadow: 0 0 0 1000px @bg-input inset;
}
//服务协议
.service-agreement {
  margin-top: 12px;
  text-align: center;
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  a {
    font-weight: bold;
    text-decoration: underline !important;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
